module.exports = __webpack_public_path__ + "img/avatar.a85ae98f.jpg";